export default {
    'meetsMinimum': function meetsMinimum(amount) {
        if (amount) {
            return amount.amount >= 1;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/utils/GlExposureDTO.js
// module id = 832
// module chunks = 0